export default "__VITE_ASSET__CqSKa$p8__"